<template style="background-color:black;">
<b-container>
    <div ref="dropin-container" id="dropin-container"></div>
    <b-modal ref="firstPayment" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Welcome to Quanteec</h3>
      </div>
      <div class="d-block text-center">
        <p>Free-tier limitations have been removed. A new domain name with your full ressources will be created within 24h.</p>
      </div>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="reloadPage();hideModal('firstPayment');">Close</b-btn>
      </b-row>
    </b-modal>
</b-container>
</template>

<script>
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';

import PaymentService from '@/services/payment.service';
let paymentService = new PaymentService();

export default {
  name: "Payment",
  props: [
    'value'
  ],
  data: function() {
    return {
     
    };
  },
  mounted() {
      this.getPaymentMethods();
  },
  methods: {
      getPaymentMethods() {
        paymentService.getPaymentMethods(this.value, this.$auth.token()).then(res => {
            this.manageConfig(res)
        }).catch(err => {
            console.log(err);
        })
      },
      makePayment(data) {
          let self = this;
          return new Promise((done, reject) => {
              paymentService.postPayment(data, this.value, self.$auth.token()).then((result) => {
                done(result);
              }).catch(err => {
                reject(err);
              })
              
          }) 
      },
      makeDetailsCall(data) {
          let self = this;
          return new Promise((done, reject) => {
              paymentService.postPaymentDetails(data, self.$auth.token()).then((result) => {
                done(result);
              }).catch(err => {
                reject(err);
              })
              
          }) 
      },
      manageConfig(input) {
          let self = this;
          const configuration = {
            paymentMethodsResponse: input.paymentMethods, // The `/paymentMethods` response from the server.
            clientKey: input.key, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
            locale: input.locale,
            environment: input.environment.toLowerCase(),
            onSubmit: (state, dropin) => {
                // Global configuration for onSubmit
                // Your function calling your server to make the `/payments` request
                self.makePayment(state.data)
                .then(response => {
                    if (response.action) {
                        // Drop-in handles the action object from the /payments response
                        dropin.handleAction(response.action);
                    } else {
                        // Your function to show the final result to the shopper
                        self.showFinalResult(response, dropin);
                    }
                })
                .catch(error => {
                    self.showFinalResult({response: {resultCode: 'Error', refusalReason: 'Can not make the payment. Please retry later.'}}, dropin);
                });
            },
            onAdditionalDetails: (state, dropin) => {
                // Your function calling your server to make a `/payments/details` request
                self.makeDetailsCall(state.data)
                    .then(response => {
                        if (response.action) {
                            // Drop-in handles the action object from the /payments response
                            dropin.handleAction(response.action);
                        } else {
                            // Your function to show the final result to the shopper
                            self.showFinalResult(response, dropin);
                        }
                    })
                    .catch(error => {
                        self.showFinalResult({response: {resultCode: 'Error', refusalReason: 'Can not make the payment. Please retry later.'}}, dropin);
                    });
            },
            amount: {
                 value: this.value, 
                 currency: 'EUR' 
            },
            paymentMethodsConfiguration: {
                showStoredPaymentMethods: false,
                card: { // Example optional configuration for Cards
                    hasHolderName: true,
                    holderNameRequired: true,
                    enableStoreDetails: true,
                    billingAddressRequired: true,
                    name: 'Credit or debit card',
                }
            }
        };
        this.checkout = new AdyenCheckout(configuration);
        this.integration = this.checkout.create('dropin', {
            // Starting from version 4.0.0, Drop-in configuration only accepts props related to itself and cannot contain generic configuration like the onSubmit event.
            openFirstPaymentMethod: true
        }).mount(self.$refs['dropin-container']);
      },
      showFinalResult(response, dropin) {
        let isOk = false;
        switch(response.resultCode) {
            case 'Authorised':
                isOk = true;
                dropin.setStatus('success', { message: 'Payment accepted. Hope you will enjoy the Quanteec products !' });
                break;
            case 'Error':
                dropin.setStatus('error', { message: 'Payment refused. ' + response.refusalReason });
                break;
            case 'Pending':
                isOk = true;
                dropin.setStatus('success', { message: 'Payment received, waiting for validation.' });
                break;
            case 'PresentToShopper':
                isOk = true;
                dropin.setStatus('success', { message: 'Payment received, waiting for validation.' });
                break;
            case 'Refused':
                dropin.setStatus('error', { message: 'Payment refused. You can try the payment again using a different payment method or card' });
                break;
            case 'Received':
                isOk = true;
                dropin.setStatus('success', { message: 'Payment received, waiting for validation.' });
                break;
            default:
                dropin.setStatus('error', { message: 'Payment refused. You can try the payment again using a different payment method or card' });
                break;
        }

        if (this.$auth.getMyUser().client_infos[0].price === 0 && isOk) {
            this.showModal('firstPayment')
        } else if (isOk) {
            this.reloadPage();
        }
        
      },
      showModal(ref) {
        this.$refs[ref].show();
      },
      hideModal(ref) {
        this.$refs[ref].hide();
      },
      reloadPage() {
          setTimeout(function() {
                window.location.reload();
            }, 3000);
      }
    
  }
};
</script>


<style scoped lang="scss">

</style>
